import { usePost } from '../../HttpClient';
import { tenantHierarchyBaseUrl } from '../BaseUrls';
import { useMutationWithErrorHandling } from '../../../hooks/UseMutationWithErrorHandling';

export function useCreateAccountTreatmentIndicator() {
  const post = usePost(true, "tms");
  const createAccountTreatmentIndicator = (request: any) =>
    post<{ id: string }>(`${tenantHierarchyBaseUrl}/account-treatment-indicators`, request);

  return useMutationWithErrorHandling({
    mutationFn: async (request: any) => await createAccountTreatmentIndicator(request),
  });
}
